import React from "react";
import IntFileLogDetail from "../component/IntFileLogDetail";

const IntFileLogDetailContainer = ({ pageId }) => (<IntFileLogDetail pageId={ pageId} />)

export default IntFileLogDetailContainer;
